module.exports = __webpack_public_path__ + "img/icons8-analytics-100_75.f7cdff1f.png";